import React from 'react';
import ProgressBar from "@Generic/loaders/ProgressBar";
import {useTranslation} from "@Translation/hooks/useTranslation";
import useIsFerry from "@GetByFerry/hooks/useIsFerry";
import Row from "@Containers/components/Row";
import ScoreWithStarDisplay from "@Pages/reviews/components/ScoreWithStarDisplay";
import Translation from "@Translation/components/Translation";

interface OverallScoreProps {
    companySubscore: {
        comfortableRideScore: string,
        driverScore: string,
        overallScore: string,

    },
    numberOfRatings: string,
    leaveAReviewLink: string,
    overallScore: string
}

function OverallScore(props: OverallScoreProps) {
    const isFerry = useIsFerry();
    const {
        tidiness_score: tidinessScoreLabel,
        value_for_money_score: valueForMoneyScoreLabel,
        comfortable_ride_score: comfortableRideScoreLabel,
    } = useTranslation("place_review.company_ratings")
    const driverOrPunctualityScoreLabel = useTranslation((isFerry)
        ? "place_review.company_ratings.punctuality_score"
        : "place_review.company_ratings.driver_score");

    const {
        overallScore,
        companySubscore: {
            driverScore,
            tidinessScore,
            valueForMoneyScore,
            comfortableRideScore
        },
        numberOfRatings,
        leaveAReviewLink
    } = props

    const roundAndConvert = (string: string) => (parseFloat(string).toFixed(1))

    return (
        <section className="gb--card-reviews gb--card-default">
            <Row justify center>
                <ScoreWithStarDisplay score={overallScore} numberOfRatings={numberOfRatings}/>
                <a className={"btn btn--green btn--review gb--leave-review-button"} href={leaveAReviewLink}>
                    <Translation translationKey="global_review_page.review_scores.cta"/>
                </a>
            </Row>
            <hr/>
            <div className="gb--grid-2c">
                <div className="gb--rating-property">
                    <small className="gb--rating-label">
                        {driverOrPunctualityScoreLabel}
                    </small>
                    <ProgressBar
                        percentage={roundAndConvert(driverScore)}
                        displayValue
                        convertToPercentage
                    />
                </div>
                <div className="gb--rating-property">
                    <small className="gb--rating-label">
                        {tidinessScoreLabel}
                    </small>
                    <ProgressBar
                        percentage={roundAndConvert(tidinessScore)}
                        displayValue
                        convertToPercentage
                    />
                </div>
                <div className="gb--rating-property">
                    <small className="gb--rating-label">
                        {valueForMoneyScoreLabel}
                    </small>
                    <ProgressBar
                        percentage={roundAndConvert(valueForMoneyScore)}
                        displayValue
                        convertToPercentage
                    />
                </div>
                <div className="gb--rating-property">
                    <small className="gb--rating-label">
                        {comfortableRideScoreLabel}
                    </small>
                    <ProgressBar
                        percentage={roundAndConvert(comfortableRideScore)}
                        displayValue
                        convertToPercentage
                    />
                </div>
            </div>
        </section>
    );
}

export default OverallScore